import { computed, reactive } from 'vue';
import { useStore } from 'vuex';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { useSnackbar } from 'vue3-snackbar';

export default function useMotivosConsultaForm(service) {
    const store = useStore();
    const snackbar = useSnackbar();

    const state = reactive({
        id: '',
        name: '',
        type: '',
        status: 1,
    });

    const setState = (c) => {
        state.id = c.id;
        state.name = c.name;
        state.type = c.type;
        state.formType = c.formType;
        state.status = c.status;
    };

    /** ***** Validator ***** */
    const rules = computed(() => ({
        name: { required },
        type: { required },
        // formType: { required },
    }));

    const v = useVuelidate(rules, state);

    const resetForm = () => {
        v.value.$reset();
        state.id = '';
        state.name = '';
        state.type = '';
        state.formType = '';
        state.status = 1;
    };

    const handleAction = async (action) => {
        if (await v.value.$validate()) {
            let text;
            switch (action) {
                case 'create':
                case 'create_view':
                    await service.createMotivosconsulta(state);
                    if (action === 'create_view') {
                        store.dispatch('ContentManager/openWindow', {
                            id: `MotivosConsultaForm_${service.motivoconsulta.value.id}`,
                            component: 'MotivosConsultaForm',
                            name: service.motivoconsulta.value.name,
                            params: {
                                title: 'Consulta',
                                headerTitle: `Ver ${service.motivoconsulta.value.name}`,
                                item: { ...service.motivoconsulta.value },
                            },
                        });
                    }
                    text = 'Motivo de Consulta credo con exito';
                    resetForm();
                    break;
                case 'save':
                    await service.updateMotivosconsulta(state.id, state);
                    text = 'Motivo de Consulta actualizado con exito';
                    break;
                default:
                    break;
            }
            snackbar.add({
                type: 'success',
                text,
            });
        } else {
            console.log(v.$errors);
            snackbar.add({
                type: 'error',
                text: 'Ups no podemos enviar la informacion sin algunos datos',
            });
        }
    };

    return {
        v,
        state,
        setState,
        resetForm,
        handleAction,
    };
}
